export const GET_USERS = 'GET_USERS'
export const GET_PROFILE = 'GET_PROFILE'